'use client';

import clsx from 'clsx';
import { useRouter } from 'next/navigation';

import { IconsId } from '@/types/icons';

import styles from './Icon.module.scss';

type IconProps = React.ComponentPropsWithoutRef<'i'> & {
    name: IconsId;
    className?: string;
    onClick?: React.MouseEventHandler<HTMLElement>;
    func?: 'goBack';
};

export const Icon: React.FC<IconProps> = ({ name, className, onClick, func, ...props }) => {
    const router = useRouter();
    return (
        <i
            className={clsx(`icon-${name}`, className, styles.icon)}
            onClick={e => (func === 'goBack' ? router.back() : onClick?.(e))}
            {...props}
        />
    );
};
